import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14 11.001a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4.799c-.993 0-1.8-.807-1.8-1.8 0-.992.807-1.8 1.8-1.8s1.8.807 1.8 1.8-.807 1.8-1.8 1.8zM4 6.999a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4 2.2c.993 0 1.8.807 1.8 1.8S4.993 5.8 4 5.8 2.2 4.992 2.2 4 3.007 2.2 4 2.2zm11.576-.623l-14 13.998.849.848 14-13.998-.849-.848z" />
  </svg>
);

export default SvgComponent;
